import { queryOptions } from '@tanstack/react-query'

import { api } from '~/lib/api'
import { queryKeys } from '~/lib/queryKeys'

export const billingCatalogQueryOptions = (selfHosted: boolean | undefined) =>
  queryOptions({
    queryKey: queryKeys.billing.catalog(),
    queryFn: () => api.billing.getCatalog(),
    enabled: selfHosted === false,
    staleTime: 10 * 60 * 1000
  })

export const billingStateQueryOptions = (params: {
  workspaceId: string | undefined
  selfHosted: boolean | undefined
}) =>
  queryOptions({
    queryKey: queryKeys.billing.state(params.workspaceId!),
    queryFn: () => api.billing.getState(),
    enabled: !!params.workspaceId && params.selfHosted === false,
    staleTime: 30 * 1000
  })
